export default {
  data() {
    return {
      searchSchema: [
        {
          label: 'Segmentlevel',
          type: 'input',
          itemName: 'segmentLevel',
          allowClear: true,
        },
        {
          label: '链路',
          type: 'select',
          itemName: 'link',
          selectList: [
            { text: 'S4', value: 1 },
            { text: 'ECC', value: 2 },
          ],
          allowClear: true,
        },
      ],
      searchForm: {
        segmentLevel: '',
        link: '',
      },
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
        showTotal: total => `共${total}条`,
      },
      tableData: [],
      tableColumns: [
        {
          fixed: 'left',
          title: '序号',
          align: 'center',
          width: 60,
          customRender: (text, record, index) => {
            return (
              (this.pageData.current - 1) * this.pageData.pageSize + index + 1
            )
          },
        },
        {
          title: '业务类型',
          width: 100,
          dataIndex: 'bgName',
        },
        {
          title: 'Segmentlevel',
          width: 160,
          dataIndex: 'segmentLevel',
        },
        {
          title: '链路',
          width: 80,
          align: 'center',
          dataIndex: 'linkName',
        },
        {
          title: '排序',
          width: 60,
          align: 'center',
          dataIndex: 'sort',
        },
        {
          title: '编辑时间',
          width: 180,
          align: 'center',
          dataIndex: 'updateTime',
        },
        {
          title: '编辑人ITCode',
          width: 160,
          dataIndex: 'username',
        },
        {
          title: '编辑人名称',
          width: 160,
          dataIndex: 'name',
        },
        {
          title: '操作',
          width: 200,
          align: 'center',
          fixed: 'right',
          scopedSlots: { customRender: 'action' },
        },
      ],
    }
  },
  methods: {
    // 查询
    handleSearch(data) {
      this.searchForm = { ...this.searchForm, ...data }
      this.pageData.current = 1
      this._getTableData()
    },
    // 点击分页按钮
    handleClickPage({ current, pageSize }) {
      this.pageData = { ...this.pageData, current, pageSize }
      this._getTableData()
    },
  },
}
